module.exports = __webpack_public_path__ + "img/copy_filled_24.e0140253.svg";